import React from 'react';

import {
  getLoginUrl,
  loginAction,
} from '../../../../../../../public-src/core/js/schibsted-account/index.server.js';
import { useSessionData } from '../../../../../../../public-src/core/js/schibsted-account/react.server.js';
import { LinkWithPulse } from '../../../../../../core/mandatory-integrations/pulse/components/LinkWithPulse.js';

export const LoginBar: React.FC = () => {
  const session = useSessionData();

  return (
    <div className="loginbar">
      <div className="login-title">Les videre med abonnement</div>
      <div className="login-link">
        {!session ? (
          <>
            Allerede abonnent?{' '}
            <LinkWithPulse
              className="action-link"
              href={getLoginUrl()}
              objectId="salesposter:login-button"
              name="Login link in salesposter"
              onResolveAction={() =>
                loginAction({ state: `vink-${window.location.href}` })
              }
              preventDefaultAction={true}
            >
              Logg inn
            </LinkWithPulse>
          </>
        ) : (
          <LinkWithPulse
            className="action-link"
            href="https://www.aftenposten.no/minside"
            objectId="salesposter:profile-button"
            name="user profile link in salesposter"
          >
            Gjør endringer på Min Side
          </LinkWithPulse>
        )}
      </div>
    </div>
  );
};
